import usePolicies from './usePolicies';

export default usePolicies;
